export enum ManifoldTabEnum {
  RESEARCH = 'Research',
  NOTEBOOK = 'Notes',
  CITATIONS = 'Citations',
  // ANALYTICS = 'Analytics',
  // PARAPHRASER = 'Paraphraser',
  // SUMMARIZER = 'Summarizer',
}

export enum ManifoldTabEnumBottomToolbar {
  // ANALYTICS = 'Analytics',
  PARAPHRASER = 'Paraphraser',
  SUMMARIZER = 'Summarizer',
}

export enum ManifoldTabEnumMiscellaneous {
  // ANALYTICS = 'Analytics',
  VOICE_TRANSCRIPT = 'Dictate',
}
